import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, interval, takeWhile } from 'rxjs';
import { AppConfigService } from '../config.service';
import { IPaymentGateway } from './payment-gateway.interface';
import { PaymentRequest, PaymentStatusResponse } from '@core/models/payment';

/**
 * Adyen payment gateway implementation
 */
@Injectable()
export class AdyenPaymentGateway extends IPaymentGateway {
  private readonly http = inject(HttpClient);
  private readonly appConfigService = inject(AppConfigService);

  //create a payment request
  createPaymentRequest(request: PaymentRequest): Observable<any> {
    return this.http.post(
      `${this.appConfigService.host()}/payments/requests`,
      request
    );
  }

  //set the processor information for the payment request
  setPaymentProcessor(requestId: string, gatewayId: string): Observable<any> {
    return this.http.post(
      `${this.appConfigService.host()}/payments/requests/${requestId}/processor`,
      { paymentGatewayId: gatewayId }
    );
  }

  //send the payment request to the terminal
  sendPaymentToTerminal(requestId: string, gatewayId: string, terminalId?: string): Observable<any> {
    const terminal = terminalId || this.appConfigService.currentConfig().terminalId;
    
    return this.http.post(
      `${this.appConfigService.host()}/payments/gateways/${gatewayId}/terminals/payments`,
      {
        paymentRequestId: requestId,
        terminalId: terminal,
      }
    );
  }

  //poll the payment status (each 1000ms)
  checkPaymentStatus(requestId: string, gatewayId: string, terminalId?: string): Observable<PaymentStatusResponse> {
    const terminal = terminalId || this.appConfigService.currentConfig().terminalId;
    
    return interval(1000).pipe(
      switchMap(() => 
        this.http.get<PaymentStatusResponse>(
          `${this.appConfigService.host()}/payments/gateways/${gatewayId}/terminals/payments/${requestId}?terminalId=${terminal}`
        )
      ),
      takeWhile((res: PaymentStatusResponse) => res.status === 'PENDING', true)
    );
  }
}

